import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'getimg.ai Case Study | Canny';
const Description =
  'Read about how getimg.ai prioritizes feature development using Canny&apos;s feedback boards and user voting system.';
const Image = 'https://canny-assets.io/images/b98d1e4285edbd32ba5b44b0f3a0e3f9.png';
const GetimgaiUrl = 'https://canny.io/case-studies/getimgai';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${GetimgaiUrl}#webpage`,
    url: GetimgaiUrl,
    name: 'Case Study: getimg.ai × Canny',
    description:
      "How getimg.ai prioritizes feature development using Canny's feedback boards and user voting system.",
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${GetimgaiUrl}#article`,
    genre: 'Case Study',
    headline:
      "How getimg.ai prioritizes feature development using Canny's feedback boards and user voting system",
    description:
      'With millions of users and over 1 million images processed daily, getimg.ai needed better feedback organization. Switching from spreadsheets to Canny, they gathered hundreds of posts and thousands of votes, prioritized the Image-to-Prompt feature and adopted a changelog—freeing up ~8 hours per month in feedback management.',
    inLanguage: 'en',
    url: GetimgaiUrl,
    mainEntityOfPage: { '@id': `${GetimgaiUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'getimg.ai', url: 'https://getimg.ai' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'getimg.ai', item: GetimgaiUrl },
  ]),
]);

const GetimgAILandingHelmet = () => (
  <Helmet
    title={Title}
    meta={[
      { name: 'description', content: Description },

      { property: 'og:image', content: Image },
      { property: 'og:title', content: Title },
      { property: 'og:description', content: Description },
      { property: 'og:url', content: GetimgaiUrl },
      { property: 'og:type', content: 'website' },

      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:site', content: '@cannyHQ' },
      { name: 'twitter:title', content: Title },
      { name: 'twitter:description', content: Description },
      { name: 'twitter:image', content: Image },
    ]}>
    <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
  </Helmet>
);

export default GetimgAILandingHelmet;
